export const StrategyList = [
  { desc: `Personalized customer Interaction` },
  { desc: `Simplified catalog sharing` },
  { desc: `Effortless sales tracking` },
  { desc: `Boost conversion rates` },
  { desc: `High Engagement` }
];
